import { Catchable, catchable } from '@wearejh/swagger-rxjs/utils/ajax-helpers';
import { concat, Observable, of } from 'rxjs';
import { pluck } from 'rxjs/operators';

import { AppendState, UserState } from '../user.reducer';
import { UserMsg } from '../user.actions';

export function catchableSignout(fn: (...args: any[]) => Observable<any>) {
    return catchable(({ error, code, status }) => {
        const after = fn({ error, code, status });
        return concat(of(UserMsg('User.SignOut')), after);
    });
}

export function catchableUnauthenticated(fn: (params: Catchable) => Observable<any>) {
    return catchable(({ error, code, status, errors }) => {
        const after = fn({ error, code, status, errors });
        if (status === 401) {
            return concat(
                of(
                    /**
                     * This message will clear user data
                     */
                    UserMsg('User.SignOut'),
                    /**
                     * This is a 'fire and forget' message that
                     * can be 'listened' to by an application in order to decide
                     * what to do
                     */
                    UserMsg('User.Unauthenticated'),
                ),
                after,
            );
        }
        return after;
    });
}

export function userData(state$: Observable<AppendState>): Observable<UserState['data']> {
    return state$.pipe(pluck<AppendState, 'user', 'data'>('user', 'data'));
}
